import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { sound } from "@pixi/sound";
import { gsap } from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { PixiPlugin } from "gsap/PixiPlugin";
import * as PIXI from "pixi.js";
import { BitmapText } from "pixi.js";
import { isSuperQuickBtnOnGlobal } from "../../config/GlobalVariableConfig";
import { MULTI_POS, REEL_DIVIDER, REEL_FRAME, REEL_NUMBERS, REEL_WIDTH, SYMBOL_HEIGHT, SYMBOL_WIDTH, SYMBOLS_PER_REEL } from "../../config/reelConfig";
import { DisplayComponent } from "../../core/displays/DisplayComponent";
import { DisplayObject, IDisplayObject } from "../../core/displays/DisplayObject";
import { Manager } from "../../core/Manager";
import {
    getLineWinSegmentGlobalPoint,
    playLineWinMultiplierMergeFx,
    playLineWinTextMultiplierMergePop,
} from "../../core/reels/ReelWin";
import { GameConstants } from "../../gameClientEvents/GameConstants";
import { SoundConstants } from "../../gameClientEvents/soundConstants";
import { HighlightFrames } from "../highlight/HighlightFrames";
import { HighlightFramesComponent } from "../highlight/HighlightFramesComponent";
import { ReelCellComponent } from "../reelCellContainer/ReelCellComponent";

gsap.registerPlugin(PixiPlugin, MotionPathPlugin);
PixiPlugin.registerPIXI(PIXI);

type textMeter = {
    text: BitmapText;
    reelNumber: number;
    posNumber: number;
};

export class WinMeterContainer extends DisplayObject {
    private multiplierTextInstances: textMeter[] = [];
    private labelName: string = "multiplier_";
    private symbolList: Spine[] = [];
    private prevTotalMulti: number = 0;
    // private centerOffset: number = 110;
    // private multiplieryOffset: number = 10;
    //private effectAnim: Spine;
    private activeTweens: gsap.core.Tween[] = [];

    constructor(config: IDisplayObject) {
        super(config);
        // this.effectAnim = Spine.from({
        //     skeleton: "particleEffectSkel",
        //     atlas: "particleEffectAtlas",
        // });
        // this.effectAnim.visible = false;
        // this.effectAnim.label = "particleEffect";
        this.setPositionResize(Manager.Orientation || "LANDSCAPE");
        this.init();
        //this.addChild(this.effectAnim);
    }

    private init(): void {
        for (let i = 0; i < REEL_NUMBERS; i++) {
            for (let j = 0; j < REEL_NUMBERS; j++) {
                this.setupMeter(i, j);
            }
        }
    }

    public setupMeter(reelNum: number, posNum: number, multiplier: number = 1) {
        //this.symbolList = [];
        //this.multiplierTextInstances = [];
        const labelName = this.labelName + reelNum + "_" + posNum;
        // if (this.getBitmapTextByLabel(labelName) != undefined) {
        //     return;
        // }
        const multVal = multiplier;
        const multText = new BitmapText({
            text: `${multVal}x`,
            style: {
                fontFamily: 'symbol_multiplier',
                fontSize: 50
            }
        });
        multText.label = labelName;
        multText.anchor = 0.5;
        multText.visible = false;
        this.multiplierTextInstances.push({ text: multText, reelNumber: reelNum, posNumber: posNum });
        multText.scale = 0;
        const x = REEL_FRAME + Math.round(SYMBOL_WIDTH / 2) + reelNum * (REEL_WIDTH + REEL_DIVIDER);
        const y = REEL_FRAME + Math.round(SYMBOL_HEIGHT / 2) + posNum * SYMBOL_HEIGHT;
        multText.x = x + MULTI_POS;
        multText.y = y + MULTI_POS;
        this.addChild(multText);
    }

    public async showMultiplier(reelNum: number, posNum: number, multiplier: number = 1, callback?: () => void): Promise<void> {
        //return new Promise<void>((resolve) => {
        const labelName = this.labelName + reelNum + "_" + posNum;
        let multiplierInst = this.getChildByLabel(labelName) as BitmapText;
        multiplierInst.text = `${multiplier}x`;
        multiplierInst.scale = 0.75;
        //multiplierInst.visible = true;
        const symbolPoint = multiplierInst.getGlobalPosition();//DisplayComponent.get(ReelComponent).getInstance().symFinalPos[reelNum][posNum];//allReelArray[reelNum].symbols[posNum].symbol;
        const point = this.toLocal(symbolPoint);
        //multiplierInst.position.set(point.x + MULTI_POS, point.y + MULTI_POS);
        const start = new PIXI.Point(point.x - MULTI_POS, point.y - MULTI_POS);
        const center = new PIXI.Point(point.x, point.y);
        const duration = isSuperQuickBtnOnGlobal ? 0.05 : 0.1;
        const fly = new BitmapText({
            text: multiplierInst.text,
            style: multiplierInst.style
        });
        fly.x = start.x;
        fly.y = start.y;
        fly.anchor.set(0.5);
        fly.scale.set(0);
        fly.alpha = 1;
        fly.label = "flyingMultiplier";
        fly.visible = true;
        this.addChild(fly);
        const path = [
            { x: start.x, y: start.y },
            { x: center.x, y: center.y }
        ];
        const tl = gsap.timeline({
            onComplete: async () => {
                multiplierInst.visible = true;
                this.removeChild(fly);
                fly.destroy();
                await DisplayComponent.get(ReelCellComponent).getInstance().playMultiMerge(reelNum, posNum);
                callback?.();
            }
        });
        tl.to(fly.scale, {
            x: 1.2,
            y: 1.2,
            duration: isSuperQuickBtnOnGlobal ? 0.1 : 0.2,
            ease: "back.out(2)",
            onStart: () => {
                sound.play(SoundConstants.MULTIPLIERS_MOVE, { volume: 0.8 });
            },
        });
        tl.to(fly, {
            delay: isSuperQuickBtnOnGlobal ? 0.3 : 0.6,
            motionPath: {
                path: path,
                curviness: 1.5,
                autoRotate: false
            },
            x: center.x,
            y: center.y,
            //scale: 0.7,
            duration: duration,
            ease: "sine.inOut",
        });
        tl.to(fly.scale, {
            x: 0.6,
            y: 0.6,
            duration: isSuperQuickBtnOnGlobal ? 0.05 : 0.1,
            ease: "back.out(2)"
        }, "<");
        //});
    }

    public async addMultiplier(reelNum: number, posNum: number, multiplier: number = 1, targetMulti: number = 1, callback?: () => void): Promise<void> {
        //return new Promise<void>((resolve) => {
        const labelName = this.labelName + reelNum + "_" + posNum;
        let multiplierInst = this.getChildByLabel(labelName) as BitmapText;
        //multiplierInst.text = `${multiplier}x`;
        multiplierInst.scale = 0.75;
        //multiplierInst.visible = true;
        const symbolPoint = multiplierInst.getGlobalPosition();//DisplayComponent.get(ReelComponent).getInstance().symFinalPos[reelNum][posNum];//allReelArray[reelNum].symbols[posNum].symbol;
        const point = this.toLocal(symbolPoint);
        //multiplierInst.position.set(point.x + MULTI_POS, point.y + MULTI_POS);
        const start = new PIXI.Point(point.x - MULTI_POS, point.y - MULTI_POS);
        const center = new PIXI.Point(point.x, point.y);
        const duration = isSuperQuickBtnOnGlobal ? 0.05 : 0.1;
        const fly = new BitmapText({
            text: `${multiplier}x`,//multiplierInst.text,
            style: multiplierInst.style
        });
        fly.x = start.x;
        fly.y = start.y;
        fly.anchor.set(0.5);
        fly.scale.set(0);
        fly.alpha = 1;
        fly.label = "flyingMultiplier";
        fly.visible = true;
        this.addChild(fly);
        const path = [
            { x: start.x, y: start.y },
            { x: center.x, y: center.y }
        ];
        const tl = gsap.timeline({
            onComplete: async () => {
                multiplierInst.visible = true;
                multiplierInst.text = `${targetMulti}x`;
                this.removeChild(fly);
                fly.destroy();
                await DisplayComponent.get(ReelCellComponent).getInstance().playMultiMerge(reelNum, posNum);
                callback?.();
            }
        });
        tl.to(fly.scale, {
            x: 1.2,
            y: 1.2,
            duration: isSuperQuickBtnOnGlobal ? 0.1 : 0.2,
            ease: "back.out(2)",
            onComplete: () => {
                (DisplayComponent.get(HighlightFramesComponent).getInstance() as HighlightFrames).hide(reelNum, posNum);
            }
        });
        tl.to(fly, {
            delay: isSuperQuickBtnOnGlobal ? 0.4 : 0.8,
            motionPath: {
                path: path,
                curviness: 1.5,
                autoRotate: false
            },
            x: center.x,
            y: center.y,
            //scale: 0.7,
            duration: duration,
            ease: "sine.inOut",
            onStart: () => {
                sound.play(SoundConstants.MULTIPLY_TRANSITION, { volume: 1 });
            }
        });
        tl.to(fly.scale, {
            x: 1.2,
            y: 1.2,
            duration: isSuperQuickBtnOnGlobal ? 0.05 : 0.1,
            ease: "back.out(2)"
        }, "<");
        //});
    }

    public getStatusOfMultiplier(reelNum: number, posNum: number): { visible: boolean; text: string } {
        const labelName = this.labelName + reelNum + "_" + posNum;
        const multiplierInst = this.getChildByLabel(labelName) as BitmapText;
        sound.play(SoundConstants.MULTIPLIER_AMOUNT, { volume: 0.7 });
        return {
            visible: multiplierInst.visible,
            text: multiplierInst.text
        };
    }

    public async addMultiplierToWinText(reelNum: number, posNum: number, _targetX: number, _targetY: number, lineWinText: BitmapText, winAmt: number, isWinHigherBet: boolean, currentMult?: number, callback?: () => void): Promise<void> {
        const labelName = this.labelName + reelNum + "_" + posNum;
        let multiplierInst = this.getChildByLabel(labelName) as BitmapText;
        if (!multiplierInst.visible) {
            callback?.();
            return;
        }
        multiplierInst.scale = 0.75;
        currentMult;
        const hitValue = Number(multiplierInst.text.slice(0, -1));
        const projectedText = `${winAmt.toFixed(2)} x ${this.prevTotalMulti + hitValue}`;
        const symbolPoint = multiplierInst.getGlobalPosition();
        const point = this.toLocal(symbolPoint);
        const start = new PIXI.Point(point.x, point.y);
        const flyTargetGlobal = getLineWinSegmentGlobalPoint('multiplier', projectedText);
        const center = this.toLocal(flyTargetGlobal);
        const duration = isSuperQuickBtnOnGlobal ? 0.15 : 0.3;
        const fly = new BitmapText({
            text: multiplierInst.text,
            style: multiplierInst.style
        });
        fly.x = start.x;
        fly.y = start.y;
        fly.anchor.set(0.5);
        fly.scale.set(0);
        fly.alpha = 1;
        fly.label = "flyingMultiplier";
        fly.visible = true;
        this.addChild(fly);
        const path = [
            { x: start.x, y: start.y },
            { x: center.x, y: center.y }
        ];
        const startY = fly.y;
        const hopOffset = isSuperQuickBtnOnGlobal ? 15 : 30;
        sound.play(SoundConstants.MULTIPLIER_AMOUNT_TALLY, { volume: 0.7 });
        const tl = gsap.timeline({
            onComplete: async () => {
                this.prevTotalMulti += hitValue;
                const projectedText = `${winAmt.toFixed(2)} x ${this.prevTotalMulti}`;
                this.removeChild(fly);
                fly.destroy();

                lineWinText.text = projectedText;

                playLineWinMultiplierMergeFx(projectedText);
                playLineWinTextMultiplierMergePop();

                if (/*["uk", "ontario"].indexOf(jurisdictionGlobal) !== -1 &&*/ !isWinHigherBet) {
                    sound.play('symbol_win', { volume: .6 })
                    // console.log("symbol_win = 0.2")
                }
                else {
                    // sound.play('symbol_win', { volume: .3 })
                    sound.play('symbol_win_multiply', { volume: .6 })
                    console.log("symbol_win_multiply = 0.6")
                }

                //await new Promise(resolve => setTimeout(resolve, 500));
                callback?.();
            }
        });

        // Pop → hop → fly
        tl.to(fly.scale, {
            x: isSuperQuickBtnOnGlobal ? 1.2 : 1.4,
            y: isSuperQuickBtnOnGlobal ? 1.2 : 1.4,
            duration: isSuperQuickBtnOnGlobal ? 0.08 : 0.15,
            ease: "back.out(4)"
        });

        tl.to(fly.scale, {
            x: 1.2,
            y: 1.2,
            duration: isSuperQuickBtnOnGlobal ? 0.04 : 0.08,
            ease: "power2.out"
        });

        tl.to(fly, {
            y: startY - hopOffset,
            duration: isSuperQuickBtnOnGlobal ? 0.06 : 0.12,
            ease: "power2.out"
        });

        tl.to(fly, {
            y: startY,
            duration: isSuperQuickBtnOnGlobal ? 0.04 : 0.08,
            ease: "power2.in"
        });

        tl.to(fly, {
            motionPath: {
                path: path,
                curviness: 1.5,
                autoRotate: false
            },
            x: center.x,
            y: center.y,
            duration: duration,
            ease: "power2.inOut",
            onStart: () => {
                sound.play(SoundConstants.TALLY_COUNTER, { volume: 1 });
            }
        });

        tl.to(fly.scale, {
            x: 1,
            y: 1,
            duration: duration,
        }, "<");
    }

    public resetPrevTotalMulti(): void {
        this.prevTotalMulti = 0;
    }

    public vanishMultis(reelNum: number, posNum: number) {
        const labelName = this.labelName + reelNum + "_" + posNum;
        let multiplierInst = this.getChildByLabel(labelName) as BitmapText;
        multiplierInst.text = "";
        multiplierInst.scale = 0;
        multiplierInst.visible = false;
    }

    public makeDark(reelNum: number, posNum: number) {
        const labelName = this.labelName + reelNum + "_" + posNum;
        let multiplierInst = this.getChildByLabel(labelName) as BitmapText;
        multiplierInst.tint = "0x222222";
    }

    public makeUndark() {
        for (let reelNum: number = 0; reelNum < REEL_NUMBERS; reelNum++) {
            for (let posNum: number = 0; posNum < SYMBOLS_PER_REEL; posNum++) {
                const labelName = this.labelName + reelNum + "_" + posNum;
                let multiplierInst = this.getChildByLabel(labelName) as BitmapText;
                multiplierInst.tint = "0xffffff";
            }
        }
    }

    public async beforeVanishMultis(reelNum: number, posNum: number): Promise<void> {
        return new Promise<void>((resolve) => {
            const labelName = this.labelName + reelNum + "_" + posNum;
            let multiplierInst = this.getChildByLabel(labelName) as BitmapText;
            const tween = gsap.to(multiplierInst.scale, {
                x: 0,
                y: 0,
                duration: 0.8,
                onComplete: () => {
                    this.activeTweens = this.activeTweens.filter(t => t !== tween);
                    resolve();
                }
            });
            this.trackTween(tween);
        });
    }

    public async vanishAllMultis() {
        for (let i = 0; i < this.multiplierTextInstances.length; i++) {
            const multiplierInst: BitmapText = this.multiplierTextInstances[i].text
            multiplierInst.text = "";
            multiplierInst.scale = 0;
            multiplierInst.visible = false;
            //await wait(50);
        }
    }

    public revealMultiplier(id: string, multiplier: number, symbol: Spine, symId: number = 0) {
        let multiplierInst = this.getChildByLabel(this.labelName + id) as BitmapText;
        multiplierInst.style.fontSize = (symId === GameConstants.WINDMILL_SYMBOL_ID) ? 85 : 45;
        sound.play(SoundConstants.REVEAL_MULTIPLIER, { volume: 1 });
        multiplierInst.text = `${multiplier}x`;
        multiplierInst.scale = 1;
        multiplierInst.visible = true;

        (symbol) && (symbol.addSlotObject("multiplier", multiplierInst));
        this.symbolList.push(symbol);
    }


    private trackTween(tween: gsap.core.Tween | null | undefined): void {
        if (!tween) return;
        this.activeTweens.push(tween);
    }

    private clearActiveTweens(): void {
        this.activeTweens.forEach((tween) => tween?.kill());
        this.activeTweens = [];
    }
    // public addMultiplierTravelAnimationSS(multText: BitmapText, target: BitmapText, callback: () => void) {
    //     const isQuick = isSuperQuickBtnOnGlobal;
    //     const windUpTime = isQuick ? 150 : 250;
    //     const travelTime = isQuick ? 200 : 350;
    //     const impactTime = 200;

    //     const flyText = new BitmapText({
    //         text: multText.text,
    //         style: multText.style
    //     });
    //     flyText.anchor.set(0.5);
    //     this.addChild(flyText);

    //     const startPos = this.toLocal(multText.getGlobalPosition());
    //     const endPos = this.toLocal(target.getGlobalPosition());
    //     flyText.position.set(startPos.x, startPos.y);

    //     const pullBackX = startPos.x - (endPos.x - startPos.x) * 0.15;
    //     const pullBackY = startPos.y - (endPos.y - startPos.y) * 0.15;

    //     new Tween(flyText)
    //         .to({
    //             x: pullBackX,
    //             y: pullBackY,
    //             scale: { x: 1.5, y: 1.5 }
    //         }, windUpTime)
    //         .easing(Easing.Back.Out)
    //         .onComplete(() => {
    //             new Tween(flyText)
    //                 .to({
    //                     x: endPos.x,
    //                     y: endPos.y,
    //                     scale: { x: 0.7, y: 0.7 }
    //                 }, travelTime)
    //                 .easing(Easing.Exponential.In)
    //                 .onComplete(() => {
    //                     this.removeChild(flyText);
    //                     flyText.destroy();
    //                     if (callback) callback();

    //                     new Tween(target.scale)
    //                         .to({ x: 1.4, y: 1.4 }, impactTime * 0.4)
    //                         .yoyo(true)
    //                         .repeat(1)
    //                         .easing(Easing.Quadratic.Out)
    //                         .onComplete(() => {
    //                             target.scale.set(1);
    //                         })
    //                         .start();
    //                 })
    //                 .start();
    //         })
    //         .start();
    // }

    // public addMultiplierTravelAnimationGS(multText: BitmapText, target: BitmapText, callback: () => void) {
    //     const flyText = new BitmapText({ text: multText.text, style: multText.style });
    //     flyText.anchor.set(0.5);
    //     this.addChild(flyText);

    //     const start = this.toLocal(multText.getGlobalPosition());
    //     const end = this.toLocal(target.getGlobalPosition());

    //     const peakY = Math.min(start.y, end.y) - 150;

    //     flyText.position.set(start.x, start.y);

    //     new Tween(flyText)
    //         .to({
    //             x: [start.x + (end.x - start.x) * 0.5, end.x], // bezier like path
    //             y: [peakY, end.y],
    //             scale: { x: 1.2, y: 1.2 }
    //         }, isSuperQuickBtnOnGlobal ? 300 : 600)
    //         .easing(Easing.Quadratic.Out)
    //         .onComplete(() => {
    //             this.removeChild(flyText);
    //             flyText.destroy();
    //             callback?.();

    //             new Tween(target.scale).to({ x: 1.3, y: 1.3 }, 100).yoyo(true).repeat(1).start();
    //         })
    //         .start();
    // }

    // public addMultiplierTravelAnimation_Add2(multText: BitmapText, target: BitmapText, callback: () => void) {
    //     const fly = new BitmapText({ text: multText.text, style: multText.style });
    //     fly.anchor.set(0.5);
    //     this.addChild(fly);

    //     const start = this.toLocal(multText.getGlobalPosition());
    //     const end = this.toLocal(target.getGlobalPosition());

    //     fly.position.set(start.x, start.y);

    //     const midX = start.x + (end.x - start.x) * 0.4;
    //     const midY = Math.min(start.y, end.y) - 180;

    //     gsap.timeline({
    //         onComplete: () => {
    //             this.removeChild(fly);
    //             fly.destroy();
    //             callback?.();

    //             gsap.to(target, { pixi: { scale: 1.4 }, yoyo: true, repeat: 1, duration: 0.12 });
    //         }
    //     })
    //         .to(fly, {
    //             pixi: { scale: 1.6 },
    //             duration: 0.12,
    //             ease: "back.out(3)"
    //         })
    //         .to(fly, {
    //             pixi: {
    //                 x: midX,
    //                 y: midY,
    //                 rotation: Math.PI * 0.8
    //             },
    //             duration: 0.22,
    //             ease: "power2.out"
    //         })
    //         .to(fly, {
    //             pixi: {
    //                 x: end.x,
    //                 y: end.y,
    //                 scale: 0.6,
    //                 rotation: Math.PI * 2
    //             },
    //             duration: 0.28,
    //             ease: "expo.in"
    //         });
    // }

    // public addMultiplierTravelAnimation_Add1(multText: BitmapText, target: BitmapText, callback?: () => void) {
    //     const fly = new BitmapText({ text: multText.text, style: multText.style });
    //     fly.anchor.set(0.5);
    //     this.addChild(fly);

    //     const start = this.toLocal(multText.getGlobalPosition());
    //     const end = this.toLocal(target.getGlobalPosition());

    //     const arcHeight = -100 - (Math.random() * 150);
    //     const midX = (start.x + end.x) * 0.5;
    //     const midY = Math.min(start.y, end.y) + arcHeight;

    //     gsap.set(fly, { x: start.x, y: start.y, alpha: 0, pixi: { scale: 0.5 } });

    //     const tl = gsap.timeline({
    //         onComplete: () => {
    //             this.removeChild(fly);
    //             fly.destroy();
    //             callback?.();

    //             gsap.fromTo(target, { pixi: { scale: 0.8 } }, {
    //                 pixi: { scale: 1 },
    //                 duration: 0.4,
    //                 ease: "back.out(4)"
    //             });
    //         }
    //     });

    //     tl.to(fly, { alpha: 1, pixi: { scale: 1.4 }, duration: 0.15, ease: "power2.out" })
    //         .to(fly, {
    //             duration: 0.6,
    //             ease: "sine.inOut",

    //             motionPath: {
    //                 path: [
    //                     { x: start.x, y: start.y },
    //                     { x: midX, y: midY },
    //                     { x: end.x, y: end.y }
    //                 ],
    //                 curviness: 1.5
    //             },

    //             pixi: {
    //                 rotation: 360
    //             }
    //         }, "-=0.1")
    //         .to(fly, { pixi: { scale: 0.8 }, duration: 0.2 }, "-=0.2");
    // }

    // public addMultiplierTravelAnimation_AddMP(multText: BitmapText, target: BitmapText, callback?: () => void) {
    //     const fly = new BitmapText({ text: multText.text, style: multText.style });
    //     fly.anchor.set(0.5);
    //     this.addChild(fly);

    //     const start = this.toLocal(multText.getGlobalPosition());
    //     const end = this.toLocal(target.getGlobalPosition());

    //     const arcHeight = -100 - (Math.random() * 150);
    //     const midX = (start.x + end.x) * 0.5;
    //     const midY = Math.min(start.y, end.y) + arcHeight;


    //     gsap.set(fly, { x: start.x, y: start.y, alpha: 0, scale: 0.5 });

    //     const state = { t: 0 };

    //     const tl = gsap.timeline({
    //         onComplete: () => {
    //             this.removeChild(fly);
    //             fly.destroy();
    //             callback?.();
    //             gsap.fromTo(target.scale, { x: 0.8, y: 0.8 }, { x: 1, y: 1, duration: 0.4, ease: "back.out(4)" });
    //         }
    //     });


    //     tl.to(fly, { alpha: 1, scale: 1.4, duration: 0.15, ease: "power2.out" });


    //     tl.to(state, {
    //         t: 1,
    //         duration: 0.6,
    //         ease: "sine.inOut",
    //         onUpdate: () => {
    //             const t = state.t;
    //             const invT = 1 - t;
    //             fly.x = (invT * invT * start.x) + (2 * invT * t * midX) + (t * t * end.x);
    //             fly.y = (invT * invT * start.y) + (2 * invT * t * midY) + (t * t * end.y);

    //             fly.rotation = t * Math.PI * 2;
    //         }
    //     }, "-=0.1");


    //     tl.to(fly, { scale: 0.8, duration: 0.2 }, "-=0.2");
    // }

    // public addMultiplierTravelAnimation_Add(multText: BitmapText, target: BitmapText, callback?: () => void) {
    //     const fly = new BitmapText({ text: multText.text, style: multText.style });
    //     fly.anchor.set(0.5);
    //     this.addChild(fly);

    //     const start = this.toLocal(multText.getGlobalPosition());
    //     const end = this.toLocal(target.getGlobalPosition());

    //     fly.position.set(start.x, start.y);

    //     const wave = { t: 0 };

    //     const amplitude = 22;
    //     const frequency = 3;
    //     const lift = 60;

    //     gsap.timeline({
    //         onComplete: () => {
    //             this.removeChild(fly);
    //             fly.destroy();
    //             callback?.();

    //             gsap.fromTo(
    //                 target.scale,
    //                 { x: 1, y: 1 },
    //                 { x: 1.1, y: 1.1, duration: 0.18, yoyo: true, repeat: 1, ease: "sine.out" }
    //             );
    //         }
    //     })
    //         .to(wave, {
    //             t: 1,
    //             duration: 0.85,
    //             ease: "sine.inOut",
    //             onUpdate: () => {
    //                 const waveX = Math.sin(wave.t * Math.PI * frequency) * amplitude;
    //                 const liftY = Math.sin(wave.t * Math.PI) * lift;

    //                 fly.x = start.x + (end.x - start.x) * wave.t + waveX;
    //                 fly.y = start.y + (end.y - start.y) * wave.t - liftY;

    //                 fly.rotation = Math.sin(wave.t * Math.PI) * 0.15;
    //                 fly.scale.set(1 - wave.t * 0.2);
    //             }
    //         });
    // }

    // public addMultiplierTravelAnimation_Collect2(multText: BitmapText, target: BitmapText, callback: () => void) {
    //     const fly = new BitmapText({ text: multText.text, style: multText.style });
    //     fly.anchor.set(0.5);
    //     this.addChild(fly);

    //     const start = this.toLocal(multText.getGlobalPosition());
    //     const end = this.toLocal(target.getGlobalPosition());

    //     fly.position.set(start.x, start.y);

    //     const orbitX = (start.x + end.x) * 0.5 + 120;
    //     const orbitY = (start.y + end.y) * 0.5 - 120;

    //     gsap.timeline({
    //         onComplete: () => {
    //             this.removeChild(fly);
    //             fly.destroy();
    //             callback?.();

    //             gsap.fromTo(target, { pixi: { scale: 1.3 } }, {
    //                 pixi: { scale: 1 },
    //                 duration: 0.2,
    //                 ease: "elastic.out(1, 0.4)"
    //             });
    //         }
    //     })

    //         .to(fly, {
    //             pixi: { x: orbitX, y: orbitY, rotation: Math.PI },
    //             duration: 0.25,
    //             ease: "power2.out"
    //         })

    //         .to(fly, {
    //             pixi: {
    //                 x: end.x,
    //                 y: end.y,
    //                 scale: 0.2,
    //                 rotation: Math.PI * 3
    //             },
    //             duration: 0.3,
    //             ease: "power4.in"
    //         });
    // }

    // public addMultiplierTravelAnimation_Collect1(multText: BitmapText, target: BitmapText, callback: () => void) {
    //     const fly = new BitmapText({ text: multText.text, style: multText.style });
    //     fly.anchor.set(0.5);
    //     this.addChild(fly);

    //     const start = this.toLocal(multText.getGlobalPosition());
    //     const end = this.toLocal(target.getGlobalPosition());

    //     gsap.set(fly, { x: start.x, y: start.y });


    //     const angle = Math.atan2(end.y - start.y, end.x - start.x) * (180 / Math.PI);

    //     const tl = gsap.timeline({
    //         onComplete: () => {
    //             this.removeChild(fly);
    //             fly.destroy();
    //             callback?.();


    //             gsap.timeline()
    //                 .to(target.scale, { x: 1.4, y: 0.6, duration: 0.1 })
    //                 .to(target.scale, { x: 1, y: 1, duration: 0.4, ease: "elastic.out(1, 0.3)" });
    //         }
    //     });

    //     tl.to(fly, {
    //         pixi: { scaleX: 1.8, scaleY: 0.6, rotation: angle },
    //         duration: 0.2,
    //         ease: "power2.in"
    //     })
    //         .to(fly, {
    //             pixi: {
    //                 x: end.x,
    //                 y: end.y,
    //                 scaleX: 0.2,
    //                 scaleY: 0.2
    //             },
    //             duration: 0.3,
    //             ease: "expo.in"
    //         });
    // }

    // public addMultiplierTravelAnimation_Collect(multText: BitmapText, target: BitmapText, callback?: () => void) {
    //     const fly = new BitmapText({ text: multText.text, style: multText.style });
    //     fly.anchor.set(0.5);
    //     fly.visible = false;
    //     this.addChild(fly);

    //     const start = this.toLocal(multText.getGlobalPosition());
    //     const end = this.toLocal(target.getGlobalPosition());
    //     end.y += this.multiplieryOffset;

    //     const waveAmplitude = 40;
    //     const waveFrequency = 1.5;


    //     const animationState = { p: 0 };

    //     gsap.to(animationState, {
    //         p: 1,
    //         duration: 0.8,
    //         ease: "sine.inOut",
    //         onUpdate: () => {
    //             fly.visible = true;
    //             const p = animationState.p;


    //             const curX = start.x + (end.x - start.x) * p;
    //             const curY = start.y + (end.y - start.y) * p;


    //             const wave = Math.sin(p * Math.PI * waveFrequency) * waveAmplitude;

    //             fly.x = curX;
    //             fly.y = curY + wave;


    //             const s = 1 - (0.25 * p);
    //             fly.scale.set(s);
    //         },
    //         onComplete: () => {
    //             this.removeChild(fly);
    //             fly.destroy();
    //             callback?.();

    //             gsap.fromTo(target.scale,
    //                 { x: 1, y: 1 },
    //                 { x: 1.15, y: 1.15, duration: 0.18, yoyo: true, repeat: 1, ease: "sine.out" }
    //             );
    //         }
    //     });
    // }

    // public collectAllMultipliersSpiral(
    //     texts: BitmapText[],
    //     target: Spine,
    //     callback?: () => void
    // ) {
    //     const duration = 0.9;
    //     const center = this.toLocal(target.getGlobalPosition());
    //     center.y -= this.centerOffset;

    //     texts.forEach((txt, i) => {
    //         const angleOffset = i * 0.6;
    //         const radiusStart = 160 + i * 10;

    //         const proxy = {
    //             angle: angleOffset,
    //             radius: radiusStart
    //         };

    //         const fly = new BitmapText({
    //             text: txt.text,
    //             style: txt.style
    //         });

    //         fly.anchor.set(0.5);

    //         // ✅ Spawn directly in spiral start position
    //         fly.x = center.x + Math.cos(proxy.angle) * proxy.radius;
    //         fly.y = center.y + Math.sin(proxy.angle) * proxy.radius;

    //         fly.scale.set(0.6);
    //         fly.alpha = 1;

    //         this.addChild(fly);

    //         if (txt.label === "accumWinText") {
    //             txt.visible = false;
    //         }

    //         gsap.to(proxy, {
    //             angle: angleOffset + Math.PI * 2,
    //             radius: 0,
    //             duration,
    //             ease: "sine.inOut",
    //             onUpdate: () => {
    //                 fly.x = center.x + Math.cos(proxy.angle) * proxy.radius;
    //                 fly.y = center.y + Math.sin(proxy.angle) * proxy.radius;

    //                 fly.scale.set(
    //                     0.6 + (1 - proxy.radius / radiusStart) * 0.4
    //                 );

    //                 fly.alpha = proxy.radius / radiusStart;
    //             },
    //             onComplete: () => {
    //                 this.removeChild(fly);
    //                 fly.destroy();

    //                 if (i === texts.length - 1) {
    //                     callback?.();
    //                 }
    //             }
    //         });
    //     });
    // }


    // public showTotalWinMeter(target: Spine, amount: number, callback?: () => void) {
    //     const center = this.toLocal(target.getGlobalPosition());
    //     center.y -= this.centerOffset;

    //     const totalText = new BitmapText({
    //         text: `${amount.toFixed(2)}`, style: {
    //             fontFamily: 'symbol_multiplier',
    //             fontSize: 150,
    //         }
    //     });

    //     totalText.anchor.set(0.5);
    //     totalText.visible = false;
    //     totalText.position = center;
    //     this.effectAnim.position = center;

    //     this.addChild(totalText);

    //     totalText.scale.set(0.85);
    //     totalText.alpha = 0;
    //     // totalText.y = center.y + 20; // slight offset for smooth lift

    //     const tl = gsap.timeline();

    //     tl.to(totalText, {
    //         alpha: 1,
    //         y: center.y,
    //         duration: 0.3,
    //         ease: "power2.out",
    //         onStart: () => {
    //             totalText.visible = true;
    //             this.effectAnim.visible = true;
    //             this.effectAnim.state.setAnimation(0, "in", false);
    //         }
    //     })
    //         .to(totalText.scale, {
    //             x: 1.08,
    //             y: 1.08,
    //             duration: 0.25,
    //             ease: "power3.out"
    //         }, "<")
    //         .to(totalText.scale, {
    //             x: 1,
    //             y: 1,
    //             duration: 0.2,
    //             ease: "power2.out"
    //         })
    //         // Exit
    //         // .to(totalText.scale, {
    //         //     x: 1.2,
    //         //     y: 1.2,
    //         //     duration: 0.15,
    //         //     ease: "power2.in"
    //         // })
    //         .to(totalText.scale, {
    //             x: 0,
    //             y: 0,
    //             duration: 0.15,
    //             ease: "power3.in"
    //         }, "+=0.6")
    //         .to(totalText, {
    //             alpha: 0,
    //             y: center.y,
    //             duration: 0.5,
    //             ease: "power2.in",
    //             onStart: () => {
    //                 this.effectAnim.state.setAnimation(0, "out", false);
    //             },
    //             onComplete: () => {
    //                 this.removeChild(totalText);
    //                 totalText.destroy();

    //                 this.effectAnim.visible = false;
    //                 this.effectAnim.state.clearTracks();

    //                 callback?.();
    //             }
    //         });


    // }

    public resetMultipliers() {
        this.symbolList && this.symbolList.forEach((symbol) => {
            let obj = symbol?.getSlotObject("multiplier");
            obj?.destroy();
            (obj) && (symbol.removeSlotObject("multiplier"));
        });
        this.symbolList = [];
        this.multiplierTextInstances = [];
    }

    // private getBitmapTextByLabel(label: string): BitmapText {
    //     return this.multiplierTextInstances.find(item => item.text.label === label)?.text;
    // }


    public override destroy(options?: boolean | undefined): void {
        this.clearActiveTweens();
        this.resetMultipliers();
        super.destroy(options);
        this.symbolList = [];
        this.multiplierTextInstances = [];
    }
}